/*jshint esversion: 8 */
const sleep = async (delay) => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, delay);
  });
};



export {
  sleep
};
